var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"10","justify":"center","align":"center"}},[_c('LineChartGenerator',{attrs:{"chart-options":_vm.chartOptions,"data":_vm.chartDataLine,"styles":_vm.styles}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }